import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../../src/services/apiCaller/cl_index";
import { endpoints } from "../../../src/api/ApiEndPoints";

const initialState = {
    accountDetailsData: "",
};

export const accountDetialsSlice = createSlice({
    name: "accountDetails",
    initialState,
    reducers: {
        setAccountDetailsData: (state, action) => {
            state.accountDetailsData = action.payload;
        },
    },
});

export const { setAccountDetailsData } = accountDetialsSlice.actions;

export default accountDetialsSlice.reducer;

export const fetchAccountDetails = (token) => (dispatch) => {
    let url = endpoints.accountDetails;
    const payload = {
        clientType: "mobile",
        accessToken: token,
    };
    postRequest(url, payload).then((res) => {
        if (res?.status === 200) {
            dispatch(setAccountDetailsData(res.data.result));
        }
    });
};

export const accountDetailsKYC = (token, data, kycType) => (dispatch) => {
    let url = endpoints.accountDetailsKYC;
    const payload = {
        accessToken: token,
        file: data?.idProofFile,
        idType: data?.type,
        kycType: kycType
    };
    postRequest(url, payload).then((res) => {
        if (res?.status === 200) {
            console.log("res: ", res);
        }
    });
};

